import api from '../auth';
const slug = 'api/pps/';

const PpService = () => {
    const getPps = () => {
        return api.get(slug).then((res) => res.data);
    };

    const getPpsLazy = (params) => {
        return api
            .get(slug, {
                params
            })
            .then((res) => res.data);
    };

    const getPp = (id) => {
        return api.get(slug + `show/${id}/`).then((res) => res.data);
    };

    const deletePp = (id) => {
        return api
            .delete(slug + `pp/${id}/`)
            .then((res) => res.data)
            .catch((err) => {
                return err;
            });
    };

    const createPp = (data) => {
        return api.post(slug, data).then((res) => res.data);
    };

    const updatePp = (id, data) => {
        return api.put(slug + `pp/${id}/`, data).then((res) => res.data);
    };

    const getOptions = () => {
        return api.options(slug).then((res) => res.data.actions.POST);
    };

    // custom action
    const copyPp = (id) => {
        return api.post(slug + `copy/${id}/`).then((res) => res.data);
    };

    // vlasnik-aplikacije
    const getVlasnikAplikacije = () => {
        return api.get(slug + 'vlasnik-aplikacije').then((res) => res.data);
    };

    const getDistributerGasa = () => {
        return api.get(slug + 'distributer-gasa').then((res) => res.data);
    };

    const getKorisnikAplikacije = () => {
        return api.get(slug + 'korisnik-aplikacije').then((res) => res.data);
    };

    return {
        getPps,
        getPpsLazy,
        getPp,
        deletePp,
        createPp,
        updatePp,
        getOptions,
        copyPp,
        getVlasnikAplikacije,
        getDistributerGasa,
        getKorisnikAplikacije
    };
};

export default PpService;
